module.exports = __webpack_public_path__ + "static/media/close-dark.1e6321a2.svg";